<template>
  <div class="evaluate-entry">
    <el-tabs v-model="activeTab" class="evaluate-tabs">
      <el-tab-pane label="订单评价" name="order">
        <order-evaluate v-if="activeTab === 'order'" />
      </el-tab-pane>
      <el-tab-pane label="配药服务评价" name="dispensing">
        <dispensing-evaluate v-if="activeTab === 'dispensing'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import OrderEvaluate from './orderEvaluate.vue'
import DispensingEvaluate from './dispensingEvaluate.vue'

export default {
  name: 'Evaluate',
  components: {
    OrderEvaluate,
    DispensingEvaluate
  },
  data() {
    return {
      activeTab: 'order'
    }
  }
}
</script>

<style lang="less" scoped>
.evaluate-entry {
  width: 100%;
  min-height: 100%;
  height: 100%;
  background: #ffffff;
}

.evaluate-tabs {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /deep/ .el-tab-pane {
    height: 100%;
  }

  /deep/ .el-tab-pane {
    height: 100%;
  }

  /deep/ .el-tabs__header {
    margin: 0;
    padding: 0 20px;
    background: #ffffff;
  }

  /deep/ .el-tabs__content {
    display: block;
    flex: 1;
    overflow: hidden;
  }
}
</style>